import React, { useEffect, useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { publicApi } from "../../api/http";
import PlayerDiscussionTab from "../Player/PlayerDiscussionTab";
import PlayerRankMockCard from "../../components/PlayerRankMockCard/PlayerRankMockCard";
import "../Player/Player.css";
import "./DraftHubRightPanel.css";

function DraftHubRightPanel({ playerId }) {
    const [activeTab, setActiveTab] = useState("discussion");
    const [playerRankMocks, setPlayerRankMocks] = useState([]);
    const [loadingRankings, setLoadingRankings] = useState(false);
    const [discussionCount, setDiscussionCount] = useState(0);

    useEffect(() => {
        setActiveTab("discussion");
    }, [playerId]);

    useEffect(() => {
        if (!playerId) {
            setPlayerRankMocks([]);
            return;
        }
        setLoadingRankings(true);
        publicApi.get(`/shared/get_player_mocks_and_rankings/${playerId}`)
            .then((res) => setPlayerRankMocks(Array.isArray(res.data) ? res.data : []))
            .catch(() => setPlayerRankMocks([]))
            .finally(() => setLoadingRankings(false));
    }, [playerId]);

    if (!playerId) {
        return (
            <Box className="draft-hub-right-panel draft-hub-right-panel--empty">
                <Typography variant="body2">Select a player to view discussion and rankings.</Typography>
            </Box>
        );
    }

    const discussionLabel = discussionCount > 0 ? `Discussion [${discussionCount}]` : "Discussion";
    const rankingsLabel = playerRankMocks.length > 0
        ? `Rankings [${playerRankMocks.length}]`
        : "Rankings";

    return (
        <Box className="draft-hub-right-panel">
            <Tabs
                value={activeTab}
                onChange={(_, value) => setActiveTab(value)}
                className="player-tabs draft-hub-right-tabs"
                variant="fullWidth"
            >
                <Tab value="discussion" label={discussionLabel} />
                <Tab value="rankings" label={rankingsLabel} />
            </Tabs>

            <Box className="draft-hub-right-tab-scroll">
                <PlayerDiscussionTab
                    playerId={playerId}
                    isActive={activeTab === "discussion"}
                    onCommentCountChange={setDiscussionCount}
                />

                <Box className="draft-hub-rankings-panel" hidden={activeTab !== "rankings"}>
                    {loadingRankings && (
                        <Typography variant="body2" className="draft-hub-rankings-loading">
                            Loading rankings…
                        </Typography>
                    )}
                    {!loadingRankings && playerRankMocks.length === 0 && (
                        <Typography variant="body2" className="draft-hub-rankings-empty">
                            No media rankings or mock drafts found for this player.
                        </Typography>
                    )}
                    {!loadingRankings && playerRankMocks.length > 0 && (
                        <Box className="draft-hub-rankings-list">
                            {playerRankMocks.map((playerRankMock) => (
                                <PlayerRankMockCard
                                    key={`${playerRankMock.data_point_id}-${playerRankMock.rank}`}
                                    playerRankMock={playerRankMock}
                                />
                            ))}
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
}

export default DraftHubRightPanel;
